import React, { Fragment, useEffect, useMemo, useState } from "react"
import { useFormik } from "formik"
import { connect } from "react-redux"
import _ from "lodash"
import PropTypes from "prop-types"

import TitleLabel from "../Inputs/TitleLabel"
import ButtonFixedVoice from "../ButtonFixedVoice"
import SuccessEdit from "./SuccessEdit"
import InputSearch from "../Inputs/InputSearch"
import CardInfo from "../Inputs/CardInfo"
import ModernModal from "shared/components/ModernModal"
import Typograph from "../../../../components/Typograph"
import { showToast } from "../../../../components/Toast"
import CustomerEdit from "./CustomerEdit"
import PortabilityEdit from "./PortabilityEdit"
import Loading from "../../../../components/Loading"
import ExportDataModal from "./ExportDataModal"

import styles from "./styles.css"

import {
  INITIAL_VALUES,
  TEXT_ACTION,
  WARNING_TEXT_ACTION,
  WARNING_TEXT_STATUS
} from "./constants"
import { formatDateFnsTimeZone } from "services/utils/date"
import {
  getDatesReschedule,
  getEditNumbers,
  getExportDashNumbers,
  postCancelPortability,
  postEditClient,
  postRescheduleOrSuspend
} from "services/state/fixedVoice/action"
import {
  maskCPFCPNJ,
  maskTelCustom,
  removeMaskCPFCNPJ,
  removeMaskTel
} from "services/utils/mask"
import { TEXT_ACTION_SUCCESS } from "../../constants"
import {
  checkCustomer,
  getMappedData,
  validate,
  validateExportType
} from "./helpers"

const ActionForm = ({
  action,
  type,
  openForm,
  onCloseModal,
  getEditNumbers,
  getExportDashNumbers,
  getDatesReschedule,
  postEditClient,
  postRescheduleOrSuspend,
  postCancelPortability,
  loading,
  dates,
  error
}) => {
  const [customerSelected, setCustomerSelected] = useState(null)
  const [showInfo, setInfo] = useState({ show: false, reason: "" })
  const [successModal, setSuccessModal] = useState(false)
  const [loadLocal, setLoadLocal] = useState(false)
  const [searchPhone, setSearchPhone] = useState("")

  const isEdition = action === "Editar cliente"
  const isExport = validateExportType(action)
  const isAsset = type === "ASSET"
  const buttonName = isEdition
    ? `Salvar`
    : `Salvar ${TEXT_ACTION[action].button}`

  const hasCustomerNumbers =
    checkCustomer(customerSelected, isAsset, action) &&
    checkCustomer(customerSelected, isAsset, action).hasResult

  const handleSearchCustomer = (event) => {
    setSearchPhone(event.target.value)
  }

  const onSearch = async () => {
    try {
      if (searchPhone) {
        setLoadLocal(true)
        const response = await getEditNumbers({
          partnerPhone: searchPhone,
          type
        })

        const data = _.get(response, "payload.data")
        const status = _.get(response, "payload.status")
        const result = _.get(data, "response.message")
        const customer = checkCustomer(result, isAsset, action)

        setLoadLocal(false)
        if (status === 200 && customer.hasResult) {
          setInfo({ show: false, reason: "" })
          setCustomerSelected(result)
        } else {
          const customerStatus = customer.status ? customer.status : "NOT_FOUND"
          setInfo({ show: true, reason: customerStatus })
        }
      }
    } catch (e) {
      setLoadLocal(false)
      showToast({
        type: "error",
        message: "Ocorreu um erro ao tentar encontrar portabilidade pelo número"
      })
    }
  }

  const onDownload = async () => {
    try {
      setLoadLocal(true)

      const response = await getExportDashNumbers({
        type: TEXT_ACTION[action].type
      })
      const data = _.get(response.payload, "data")
      const documentContent = _.get(data, "response.message")

      if (!documentContent) {
        setLoadLocal(false)
        showToast({
          type: "error",
          message: "Erro ao processar exportação de arquivo"
        })
        onCloseModal()
        return
      }

      const blob = new Blob([documentContent], {
        type: "text/csv;charset=utf-8;"
      })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.setAttribute("href", url)
      link.setAttribute("download", "FIXED_VOICE_CLIENT_DATA.csv")
      link.style.visibility = "hidden"

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      setLoadLocal(false)
      onCloseModal()
    } catch (e) {
      setLoadLocal(false)
      showToast({
        type: "error",
        message: "Erro ao processar exportação de arquivo"
      })
      onCloseModal()
    }
  }

  const handleResponseAction = (res, action) => {
    try {
      setLoadLocal(false)
      if (res.payload.status === 201 || res.payload.status === 200) {
        formik.resetForm()
        const isSuspended = action === "Suspender portabilidade"

        if (isSuspended) {
          setSuccessModal(true)
        } else {
          showToast({
            type: "sucess",
            acceptHtml: true,
            message: TEXT_ACTION_SUCCESS[action]
          })
          onCloseModal()
        }
      }
    } catch (e) {
      setLoadLocal(false)
      const error = _.get(res, "error.response.data.message", "Não informado")

      const messageUpdated = _.replace(
        WARNING_TEXT_ACTION[action],
        "ERROR",
        error
      )
      showToast({
        type: "error",
        acceptHtml: true,
        message: messageUpdated
      })
      onCloseModal()
    }
  }

  const formik = useFormik({
    initialValues: INITIAL_VALUES,
    validate: (values) => validate(values, action),
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoadLocal(true)
        let payload, res, number, numberDdd, numberPhone

        switch (action) {
          case "Editar cliente":
            numberPhone = removeMaskTel(values.phone)
            number = numberPhone.substring(2, numberPhone.length)
            numberDdd = `0${numberPhone.substring(0, 2)}`

            payload = {
              DDD: numberDdd,
              phoneNumber: number,
              numberKey: values.numberKey,
              franchise: "S",
              customerDocumentNumber: removeMaskCPFCNPJ(values.document),
              customerName: values.customerNewName
            }

            res = await postEditClient(payload)
            handleResponseAction(res, "Editar cliente")
            break
          case "Reagendar portabilidade":
            payload = {
              protocolId: customer.protocolId,
              actionType: "alterar_janela_de_portabilidade",
              windowAvailableDate: formatDateFnsTimeZone(
                values.time,
                "MMM dd, yyyy, h:mm:ss a",
                "yyyy-MM-dd'T'HH:mm:ss"
              )
            }

            res = await postRescheduleOrSuspend(payload)
            handleResponseAction(res, "Reagendar portabilidade")
            break
          case "Suspender portabilidade":
            payload = {
              protocolId: customer.protocolId,
              actionType: "suspender_janela_de_portabilidade"
            }

            res = await postRescheduleOrSuspend(payload)
            handleResponseAction(res, "Suspender portabilidade")
            break
          case "Cancelar portabilidade":
            payload = {
              protocolId: customer.protocolId,
              protocolItemId: customer.protocolItemId
            }

            res = await postCancelPortability(payload)
            handleResponseAction(res, "Cancelar portabilidade")
            break
        }
      } catch (e) {
        console.error("Error: ", e)
        showToast({
          type: "error",
          message:
            "Ocorreu um erro ao processar os dados da operação. Tente mais tarde!"
        })
      } finally {
        setLoadLocal(false)
        onCloseModal()
      }
    }
  })

  const datesMapped = useMemo(() => {
    if (dates) {
      return getMappedData(dates)
    }
  }, [dates])

  const customer = useMemo(() => {
    const record = _.get(customerSelected, "records[0]")
    const numberKey = _.get(customerSelected, "numberKey")

    const name = _.get(record, "NOME")
    const phone = _.get(record, "NUMERO")
    const phone2 = _.get(record, "TELEFONE")
    const document = _.get(record, "CPF/CNPJ")
    const protocol = _.get(record, "PROTOCOLO")
    const protocolId = _.get(record, "PROTOCOLO ID")
    const protocolItemId = _.get(record, "PROTOCOLO ITEM ID")
    const saleType = _.get(record, "PROTOCOLO TYPE")
    const dateAvailable = _.get(record, "JANELA PORTABILIDADE")

    return {
      name,
      phone: phone || phone2,
      document,
      numberKey,
      protocol,
      protocolId,
      protocolItemId,
      saleType,
      dateAvailable
    }
  }, [customerSelected])

  useEffect(() => {
    if (customer.name || customer.document || customer.phone) {
      formik.setFieldValue("customerNewName", customer.name)
      formik.setFieldValue("document", maskCPFCPNJ(customer.document))
      formik.setFieldValue("phone", maskTelCustom(customer.phone))
      formik.setFieldValue("numberKey", customer.numberKey)
    }
  }, [customer])

  useEffect(() => {
    if (customer.protocol && action === "Reagendar portabilidade") {
      getDatesReschedule(customer.protocol)
    }
  }, [customer])

  const onSubmitChange = () => {
    formik.handleSubmit()
  }

  return (
    <div>
      <Loading isOpen={loading || loadLocal} />

      {successModal && (
        <ModernModal
          isOpen={successModal}
          onClose={() => onCloseModal()}
          renderFooter={false}
        >
          <SuccessEdit action={action} onCloseSuccess={() => onCloseModal()} />
        </ModernModal>
      )}

      {!successModal && (
        <ModernModal
          isOpen={openForm}
          onClose={() => onCloseModal()}
          renderFooter={false}
        >
          {isExport && (
            <ExportDataModal action={action} onDownload={onDownload} />
          )}

          {!isExport && (
            <div>
              <Typograph
                htmlTag="h1"
                size="medium"
                color="outer_space"
                weight="bold"
              >
                {action}
              </Typograph>
              <div className={styles.space_title}>
                {isEdition && (
                  <Typograph
                    htmlTag="p"
                    size="medium"
                    color="outer_space"
                    weight="regular"
                  >
                    Qual cliente você deseja editar as informações?
                  </Typograph>
                )}
                {!isEdition && (
                  <Typograph
                    htmlTag="p"
                    size="medium"
                    color="outer_space"
                    weight="semi_bold"
                  >
                    {`Insira as informações ${TEXT_ACTION[action].title}`}
                  </Typograph>
                )}
              </div>

              <div className={styles.space}>
                {isEdition && (
                  <div className={styles.space_title}>
                    <TitleLabel>Buscar cliente por número</TitleLabel>
                  </div>
                )}
                <InputSearch
                  searchTerm={searchPhone}
                  handleSearch={handleSearchCustomer}
                  placeholder={"Pesquisar por telefone"}
                  onSearch={() => onSearch()}
                  className={styles.inputClass}
                />

                {showInfo.show && (
                  <CardInfo>
                    {isAsset
                      ? "Não foi encontrado nenhum cliente com esse número. Certifique-se de que ele seja um número ATIVO."
                      : WARNING_TEXT_STATUS[showInfo.reason]}
                  </CardInfo>
                )}

                {error && <CardInfo isDanger>{error}</CardInfo>}

                {hasCustomerNumbers && searchPhone && (
                  <Fragment>
                    {isEdition && (
                      <CustomerEdit
                        formikCustomer={formik}
                        customerSelected={customer}
                      />
                    )}

                    {!isEdition && (
                      <PortabilityEdit
                        formikPortability={formik}
                        action={action}
                        customerSelected={customer}
                        datesMapped={datesMapped}
                      />
                    )}
                  </Fragment>
                )}
              </div>

              {hasCustomerNumbers && searchPhone && (
                <div className={styles.container_button_save}>
                  <ButtonFixedVoice
                    name={buttonName}
                    onAction={() => onSubmitChange()}
                    className={styles.buttonSaveClass}
                  />
                </div>
              )}
            </div>
          )}
        </ModernModal>
      )}
    </div>
  )
}

ActionForm.propTypes = {
  action: PropTypes.string,
  type: PropTypes.string,
  openForm: PropTypes.bool,
  onCloseModal: PropTypes.func,
  getEditNumbers: PropTypes.func,
  getExportDashNumbers: PropTypes.func,
  getDatesReschedule: PropTypes.func,
  postEditClient: PropTypes.func,
  postRescheduleOrSuspend: PropTypes.func,
  postCancelPortability: PropTypes.func,
  loading: PropTypes.bool,
  dates: PropTypes.array,
  error: PropTypes.string
}

const mapStateToProps = ({ actionsDashFixedVoice }) => ({
  loading: actionsDashFixedVoice.loadingActions,
  dates: actionsDashFixedVoice.datesAvailable,
  error: actionsDashFixedVoice.error
})

const mapActionsToProps = {
  getEditNumbers,
  getExportDashNumbers,
  getDatesReschedule,
  postEditClient,
  postRescheduleOrSuspend,
  postCancelPortability
}

export default connect(mapStateToProps, mapActionsToProps)(ActionForm)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/ActionForm/index.js